<template>
    <table class="flex-fill table table-head-fixed table-hover text-nowrap">
        <thead style="font-size: 0.85rem">
            <tr style="color: #1976d2; font-weight: 500">
                <th class="text-center text-nowrap" style="width: 12.5rem">
                    <button>
                        <span>{{ $t('rechargeView.invoiceId') }}</span>
                    </button>
                </th>
                <th class="text-right text-nowrap" style="width: 10rem">
                    <button>
                        <span>{{ $t('rechargeView.status') }}</span>
                    </button>
                </th>
                <th class="text-left text-nowrap">
                    <button>
                        <span>{{ $t('invoice.paymentMethod') }}</span>
                    </button>
                </th>
                <th class="text-right text-nowrap" style="width: 10rem">
                    <button>
                        <span>{{ $t('payment.amountLabel') }}</span>
                    </button>
                </th>
                <th class="text-right text-nowrap" style="width: 10rem">
                    <button>
                        <span>{{ $t('billingItem.irenderPointTooltip') }}</span>
                    </button>
                </th>
                <th style="width: 1%"></th>
                <th style="width: 1%"></th>
            </tr>
        </thead>
        <tbody style="color: #616161; font-size: 0.85rem">
            <tr :key="element.id" v-for="element in listData" 
                :style="`${element.type === dict.transactionType.PROCESSING ? '#616161' : 'background-color: #F4FAF4' }`">
                <td class="v-center text-nowrap text-center pt-2 pb-2">
                    <div v-if="element.transactionId" style="text-shadow: 2px 2px #ffffff">
                        {{ element.transactionId }}
                    </div>
                    <div v-else style="color: #bdbdbd">-- -- -- -- -- -- --</div>
                </td>
                <td class="v-center text-nowrap text-right">
                    <span :class="`${dict.paymentStyleStatusText[element.status]}`"
                        style="padding: 0.25rem 0.75rem; border-radius: 1rem">
                        <i :class="`${dict.paymentStatusIcon[element.status]}`" style="font-size: 0.8rem"></i>
                        <span class="ml-2">{{
                            $t(dict.paymentStatusText[element.status])
                        }}</span>
                    </span>
                </td>
                <td class="v-center text-nowrap text-left pt-2 pb-2">
                    <div class="d-flex flex-row align-items-center">
                        <div class=" d-flex flex-row align-items-center justify-content-center mr-2 ">
                            <img style="width: 2rem"
                                :src="`/providerTransaction/${element.paymentMethodId}.svg`" />
                        </div>
                        <div class="ml-3">
                            <div style="font-weight: 500" :style="`${element.type === dict.transactionType.PROCESSING
                                    ? 'color: #757575;'
                                    : 'color: forestgreen; text-shadow: 2px 2px #ffffff;'
                                }`">
                                {{ element.paymentMethodDescription }}
                            </div>
                            <div class="mt-1" style="font-size: 0.75rem; color: #9e9e9e">
                                {{ element.lastModifiedAt | pretyDateUtcToLocal }}
                            </div>
                        </div>
                    </div>
                </td>
                <td class="v-center text-nowrap text-right pt-2 pb-2">
                    <div v-if="showPriceAsVND" style="font-weight: 500" 
                        :style="`color: ${element.type === dict.transactionType.PROCESSING ? '#616161' : 'forestgreen' }`">
                        <span class="ml-1">{{ element.amount * 25000 | formatNumberVN }}</span>
                        <span class="ml-1" style="font-weight: 500">đ</span>
                    </div>
                    <div v-else style="font-weight: 500" 
                        :style="`color: ${element.type === dict.transactionType.PROCESSING ? '#616161' : 'forestgreen' }`">
                        <span style="font-weight: 500">$</span>
                        <span class="ml-1">{{ element.amount }}</span>
                    </div>
                </td>
                <td class="v-center text-nowrap text-right pt-2 pb-2">
                    <div>
                        <div :title="$t('billingItem.irenderPointTooltip')"
                            class=" d-flex justify-content-end align-items-center flex-row "
                            :style="`${element.irenderPoint === 0 ? 'opacity: 0.25' : '' }`">
                            <div style="color: #42a5f5">
                                {{ element.irenderPoint }}
                            </div>
                            <img class="ml-2" style="opacity: 0.75"
                                src="/static/image/logo-irender-coin.svg" width="12" height="12" />
                        </div>
                        <div :title="$t('billingItem.bonusPointTooltip')"
                            class=" d-flex justify-content-end align-items-center flex-row mt-1 " 
                            :style="`${element.bonusPoint === 0 ? 'opacity: 0.25' : '' }`">
                            <div style="color: black">
                                {{ element.bonusPoint }}
                            </div>
                            <i class="el-icon-coin ml-2" style="margin-top: 0.2rem"></i>
                        </div>
                    </div>
                </td>
                <td class="v-center text-nowrap text-right pt-2 pb-2">
                    <div v-if="element.status === dict.transactionStatus.PAYING">
                        <div :title="$t('rechargeView.validTimeRemaining')" style="color: #e65100; font-size: 0.7rem">
                            <i v-if="element.timeRemaining !== 'Expired !'" class="el-icon-time mr-1"></i>
                            <span>{{ element.timeRemaining }}</span>
                        </div>
                        <el-link :href="`${element.url}`" type="primary" :underline="false"
                            target="_blank">{{ $t('rechargeView.continueToPay') }}</el-link>
                    </div>
                    <div v-if="element.status === dict.transactionStatus.TIMEOUT" style="color: #757575">
                        {{ $t('rechargeView.linkExpired') }}
                    </div>
                    <div v-if="element.status === dict.transactionStatus.SUCCESS">
                        <el-button v-if="dict.user.region === 'VN' && !element.exportInvoiceExpired && element.amount > 0"
                            :type="element.exportInvoiceId !== null ? 'success' : 'warning'
                            " round size="small" @click="actions.showExportInvoice(element)" :title="$t('rechargeView.clickToShowInvoice')">
                            {{ element.exportInvoiceId !== null ? $t('rechargeView.invoiceVat') : $t('rechargeView.exportInvoiceVat') }}
                        </el-button>
                        <el-button type="primary" round size="small"
                            @click="actions.showDetailsTransaction(element)" :title="$t('rechargeView.clickToShowInvoice')">
                            <span>{{ $t('rechargeView.invoiceButton') }}</span>
                            <i class="el-icon-arrow-right ml-2" />
                        </el-button>
                    </div>
                </td>
                <td></td>
            </tr>
        </tbody>
    </table>
</template>
<script>
export default {
    props: {
        listData: {
            type: Array,
            default() {
                return []
            }
        },
        dict: {
            type: Object,
            default() {
                return {}
            }
        },
        actions: {
            type: Object,
            default() {
                return {}
            }
        },
    },
    data() {
        return {            
            showPriceAsVND: process.env.VUE_APP_CODE === 'IRENDER_GPU_VN',
        }
    }
}
</script>